import React from 'react'
import { NavLink } from 'react-router-dom'
import Logo from '../img/logo.png'
import Banner from '../img/header.png'
import { ReactComponent as Home } from '../img/svg/icons/home-icon.svg'


export default function Navbar() {
return (
<>
    <div className="bar-blue">
        <h4>Roaring Fork Conservancy</h4>
    </div>
    <div className="header">
        <div className="logo"> <img src={Logo} alt="Roaring Fork Conservancy"  width="100px" /></div>
        <div className="button-row-1 center ">
            <div ><img src={Banner}  alt="Roaring Fork Conservancy" width="250px"/></div>
        </div>
    </div>
    <div className="col-9">
        <div className="item">
            <NavLink to="/"><Home className="home-icon" /></NavLink>
        </div>
        <div className="item">
            <NavLink to="/add"><button className="nav-button">Report a Temperature</button></NavLink>
        </div>
        <div className="item">
        <NavLink to="/detail/master"><button className="nav-button">View Current Reports</button></NavLink>
        </div>

    </div>
</>
)
}